import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../../../../../components/Buttons/ButtonCinestar/ButtonCinestar'
import ButtonQuantity from '../../../../../../../../components/Buttons/ButtonQuantity/ButtonQuantity'
import Typography from '../../../../../../../../components/Typography/Typography'

import './SnackCardContent.scss'

// TODO: Add {price} variable to formatMessage OR use Money component

const SnackCardContent = ({ title, description, price, quantity, setQuantity }) => {
    const intl = useIntl()

    return (
        <div className="snack-card-content d-flex flex-column">
            <Typography variant={'h3'}>{title}</Typography>
            <Typography variant={'desc'} color={'lighterPrimary'} className={'snack-card-content--description'}>
                {description}
            </Typography>
            <div className="d-flex align-items-center snack-card-content--quantity">
                <Typography variant={'h3'} color={'magentaSecondary'}>
                    {price} {intl.formatMessage({ id: 'global.currency.czk' })}
                </Typography>
                {quantity < 1 ? (
                    <ButtonCinestar variant={'primary-v1'} iconLeft={'plus'} onClick={() => setQuantity(1)}>
                        {intl.formatMessage({ id: 'buttons.add' })}
                    </ButtonCinestar>
                ) : (
                    <ButtonQuantity
                        quantity={quantity}
                        onClickLeft={() => setQuantity(quantity - 1)}
                        onClickRight={() => setQuantity(quantity + 1)}
                    />
                )}
            </div>
        </div>
    )
}

export default SnackCardContent
